import { useState } from "react";
import DeltaHedgeExeManagementTable from "../../../Tables/DeltaHedgeExePhase3/ExeManagement/DeltaHedgeExeManagementTable";
import { IDeltaHedgeExeManagementTableSearchParam } from "../../../Interfaces/deltaHedgeExe";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { getGroups } from "../../../Requests/optionDomain";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import AddEditTask from "./AddEditTask";
import ExeTimeModalUI from "./ExeTimeModalUI";
import { getDeltaHedgeAccountsDropdown } from "../../../Requests/deltaHedgeAccounts";

enum ModalState {
  Closed,
  AddTask,
  ExeTime,
}

const ExeManagement = () => {
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeExeManagementTableSearchParam
  );
  const [modalState, setModalState] = useState(ModalState.Closed);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const getModalUI = () => {
    switch (modalState) {
      case ModalState.AddTask:
        return (
          <AddEditTask
            editValues={null}
            onSuccess={() => setRefreshFlag(true)}
            onClose={() => setModalState(ModalState.Closed)}
          />
        );

      case ModalState.ExeTime:
        return (
          <ExeTimeModalUI onClose={() => setModalState(ModalState.Closed)} />
        );

      default:
        return <></>;
    }
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-3">
      {modalState !== ModalState.Closed ? (
        <Modal title={modalState === ModalState.ExeTime ? "تنظیمات اجرا" : "اضافه کردن"}
          onClose={() => setModalState(ModalState.Closed)}
          UI={getModalUI()}
          modalBoxClassName="!min-w-[300px]"
        />
      ) : (
        <></>
      )}
      <div className="flex flex-row justify-start items-end gap-3">
        <div className="w-[200px]">
          <DynamicMultiSelectDropdown
            dropdown={{
              placeholder: "اکانت",
              name: "accountIds",
              extraLabel: true,
            }}
            onChange={changeHandler}
            value={searchParams.accountIds}
            getData={getDeltaHedgeAccountsDropdown}
          />
        </div>
        <div className="w-[200px]">
          <DynamicMultiSelectDropdown
            dropdown={{
              placeholder: "گروه ها",
              name: "groupIds",
              extraLabel: true,
            }}
            getData={getGroups}
            value={searchParams.groupIds}
            onChange={changeHandler}
          />
        </div>
        <div className="w-[100px]">
          <Button
            text="اضافه کردن"
            onClick={() => setModalState(ModalState.AddTask)}
            variant="contained"
          />
        </div>
        <div className="w-[100px]">
          <Button
            text="تنظیمات اجرا"
            onClick={() => setModalState(ModalState.ExeTime)}
            variant="contained"
          />
        </div>
      </div>
      <DeltaHedgeExeManagementTable
        searchParams={searchParams}
        refreshFlag={refreshFlag}
        onFetchComplete={() => setRefreshFlag(false)}
      />
    </div>
  );
};

export default ExeManagement;
